import { EntityQuery } from 'breeze-client';

const baseQuery = EntityQuery.from('UserRoles');

export const userRoleQueries = {
  selectAll: baseQuery
};
